import React, { createContext, useContext, useState, useEffect } from 'react';

const PaymentCurrencyContext = createContext();

export const CURRENCY = {
  ARS: 'ARS',
  USD: 'USD',
};

export const PaymentCurrencyProvider = ({ children }) => {
  const [currency, setCurrencyState] = useState(() => {
    const stored = localStorage.getItem('paymentCurrency');
    return stored ? stored : CURRENCY.ARS;
  });

  useEffect(() => {
    localStorage.setItem('paymentCurrency', currency);
  }, [currency]);

  const setCurrency = (newCurrency) => {
    setCurrencyState(newCurrency);
  };
  return (
    <PaymentCurrencyContext.Provider value={{ currency, setCurrency }}>
      {children}
    </PaymentCurrencyContext.Provider>
  );
};

export const usePaymentCurrency = () => useContext(PaymentCurrencyContext);
